let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63lwl")).then(() => parcelRequire('hNqgv'));